<template>
  <div class="wages wrapper shadow">
    <div class="operation">
      <div class="left">
        <div class="main-title">用户管理</div>
        <el-button
          type="primary"
          class="main-btn main-btn-primary"
          @click="addData"
          >添加用户</el-button
        >
        <el-button
          :type="selectStatus"
          class="main-btn"
          :class="{ 'main-btn-warning': selectStatus == 'warning' }"
          @click="batchDel"
          >批量删除</el-button
        >
      </div>
      <div class="right">
        <el-input
          class="search-input"
          v-model="query.keyword"
          placeholder="请输入用户名"
        >
          <template #append
            ><div class="search-btn" @click="searchBtn">查询</div></template
          >
        </el-input>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      header-row-class-name="main-table-header"
      :data="tableData"
      border
      height="670"
      @selection-change="handleSelectionChange"
      @row-dblclick="dbEdit"
    >
      <el-table-column type="selection" width="38" fixed />
      <el-table-column label="用户名" min-width="110" align="center">
        <template #default="scope">
          <el-input
            v-model="scope.row.account"
            :disabled="!scope.row.editStatus"
            placeholder="请输入用户名"
          />
        </template>
      </el-table-column>
        <el-table-column label="姓名" min-width="110" align="center">
            <template #default="scope">
                <el-input
                    v-model="scope.row.name"
                    :disabled="!scope.row.editStatus"
                    placeholder="请输入姓名"
                />
            </template>
        </el-table-column>
      <el-table-column label="用户权限" min-width="115" align="center">
        <template #default="scope">
          <el-select
            :disabled="!scope.row.editStatus"
            v-model="scope.row.role.id"
            placeholder="用户权限"
          >
            <el-option
              v-for="item in roleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="250" align="center">
        <template #default="scope">
          <el-button type="primary" size="small" @click="resetClick(scope.row)"
            >重置密码</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="editClick(scope.row)"
            v-if="!scope.row.editStatus"
            >编辑</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="saveClick(scope.row)"
            v-if="scope.row.editStatus"
            >保存</el-button
          >
          <el-button type="danger" size="small" @click="deleteRow(scope.$index)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
      <el-pagination background layout="prev, pager, next, total, sizes, jumper" :total="query.total"
                     v-model:currentPage="query.page" v-model:page-size="query.pagesize" @size-change="getList"
                     @current-change="getList" :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500]" />
  </div>
</template>
<script setup>
import { ref } from "@vue/reactivity";
import { ElMessage, ElMessageBox } from "element-plus";
import dayjs from "dayjs";
import {onMounted} from "vue";
import {del, fetchList, save, batchUpdate, resetPwd } from "@/api/user";

onMounted(() => {
    getList();
    getRoleList();
});
// 添加
const addData = () => {
  tableData.value.unshift({
      role: {
        id: ''
      },
    editStatus: true,
    addTime: dayjs().format("YYYY/MM/DD HH:mm:ss"),
  });
};
//批量删除
const selectStatus = ref("info");
const batchDel = () => {
    if (SelectList.value.length == 0) {
        ElMessage.error("请至少选中一条信息！");
    } else {
        ElMessageBox.confirm("确定要删除所有选中信息吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        })
            .then(() => {
                batchUpdate({
                    ids: SelectList.value.map((e) => e.id),
                    field: "deleteflag",
                    value: 1,
                }).then(() => {
                    ElMessage.success("批量删除成功！");
                    getList();
                });
            })
            .catch(() => {});
    }
};
//搜索
const query = ref({
    keyword: "",
    page: 1,
    pagesize: 15,
    total: "",
    sort: "+id",
});
const searchBtn = () => {
    getList();
};
// 表格
const tableData = ref([]);

const getList = () => {
    fetchList(query.value).then((res) => {
        tableData.value = res.data.list;
        query.value.total = res.data.total;
    });
};
// 重置密码
const resetClick = (row) => {
  ElMessageBox.confirm("确定要重置密码为123456吗?", "Warning", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
        resetPwd({ id: row.id} ).then(() => {
            ElMessage({
                type: "success",
                message: "重置成功！",
            });
        })
    })
    .catch(() => {});
};
// 表格编辑
const editClick = (row) => {
  row.editStatus = true;
};
// 表格双击编辑
const dbEdit = (row) => {
  row.editStatus = true;
};
const saveClick = (row, idx) => {
    if (!row.role || !row.role.id) {
        ElMessage.error("请选择权限！");
        return;
    }
    if (!row.account) {
        ElMessage.error("请输入账号！");
        return;
    }
    if (!row.name) {
        ElMessage.error("请输入姓名！");
        return;
    }
  ElMessageBox.confirm("确定要保存此行信息吗?", "Warning", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
        save(row).then((res) => {
            tableData.value[idx] = res.data;
            tableData.value[idx].editStatus = false;
            ElMessage({
                type: "success",
                message: "保存成功！",
            });
        });
    })
    .catch(() => {
      // ElMessage({
      //   type: 'info',
      //   message: 'Delete canceled',
      // })
    });
};
const deleteRow = (index) => {
  ElMessageBox.confirm("确定要删除此行信息吗?", "Warning", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
        del({ id: tableData.value[index].id }).then(() => {
            getList();
            ElMessage({
                type: "success",
                message: "删除成功！",
            });
        });
    })
    .catch(() => {});
};
// 多选
const SelectList = ref([]);
const handleSelectionChange = (val) => {
  SelectList.value = val;
  console.log(SelectList.value.length);
  if (val.length > 0) {
    selectStatus.value = "warning";
  } else {
    selectStatus.value = "info";
  }
};

import {fetchList as fetchRoleList} from "@/api/role";
const roleOptions = ref([]);

const getRoleList = () => {
    fetchRoleList().then((res) => {
        let list = res.data.list;
        roleOptions.value = [];
        list.forEach((item) => {
            roleOptions.value.push({
                value: item.id,
                label: item.name,
            });
        });
    });
};
</script>
<style lang="scss">
</style>
